module.exports = __webpack_public_path__ + "static/media/github.ae2c64de.svg";